/* eslint-disable react/jsx-key */
import React, { useContext, useEffect } from "react";
import "./profileView.css";
import TopBar from "../../../components/TopBarComponent/Topbar";
import BackArrow from "../../../assets/images/Icons/backArrow.svg";
import { Container, Col, Row } from "react-bootstrap";
import { ProfilePageContext } from "../ProfileView";
import EmpImage from "../../../assets/images/empImage.svg";
import HorizontalLine from "../../../assets/images/horizontalLine.svg";
import IconProfile from "../../../assets/images/Icons/profileIcon.svg";
import IconChangePassword from "../../../assets/images/Icons/changepassword.svg";
import AlertBox from "../../../components/AlertComponent/AlertBox";
import ModalChangePassword from "../../../components/ChangePasswordComponent/ChangePassword";
import { baseURL } from "../../../api/Axios";
const ProfileViewPage = ({ textContents }) => {
  const {
    goBack,
    profileDetail,
    profileData,
    modalOpenStatus,
    setModalOpenStatus,
    passwordChange,
    oldPassword,
    setOldPassword,
    newPassword,
    setNewPassword,
    PasswordConfirm,
    setPasswordConfirm,
    passwordType,
    setPasswordType,
    userImage,
    showAlert,
    setShowAlert,
    alertMessage,
    setAlertMessage,
    handleAlertSubmit,
    setNewPasswordType,
    newPasswordType,
    confirmPasswordType,
    setConfirmPasswordType,
    newPasswordInvalid,
    setNewPasswordInvalid,
    confirmPasswordInvalid,
    setConfirmPasswordInvalid,
    oldPasswordInvalid,
    setOldasswordInvalid,
    passWordMisMatch,
    popupValueRest,
    setPasswordMisMatch,
    logout,
    statusCode,
  } = useContext(ProfilePageContext);

  // const profileDataSharing = {
  //   name: profileData[0]?.name,
  //   Image: imgPath
  // };
  // window.localStorage.setItem(
  //   "profileDataSharing",
  //   JSON.stringify(profileDataSharing)
  // );

  useEffect(() => {
    profileDetail();
  }, []);
  const imgPath = userImage ? `${baseURL}/images/${userImage}` : IconProfile;

  return (
    <div className="profileEmp-page">
      <TopBar />
      <Container>
        <div className="heading-row my-3">
          <div className="profileEmpBox" onClick={() => goBack()}>
            <img
              className="back-arrow"
              src={BackArrow}
              alt="Back Arrow"
              width={17}
            />
            <p className="profileEmpName">Profile</p>
          </div>
          <div
            className="changePaswordModalContainer"
            onClick={() => {
              popupValueRest();
              setModalOpenStatus(true);
            }}
          >
            <img src={IconChangePassword} alt="changepassword" width={17} />
            <p className="lblChangePassword">Change Password</p>
          </div>
        </div>

        <div className="profileEmpView">
          <div>
            <Row>
              <Col md={2}>
                <div className="profileEmpImgDiv">
                  <img
                    className="profileEmpDiv"
                    src={imgPath}
                    alt="ProfileEmp Image"
                  />
                </div>
              </Col>
              <Col md={5} className="profileEmpDetailDiv">
                <Row>
                  <Col md={12}>
                    <Row>
                      <Col md={4}>
                        <label className="profileEmpLabel">
                          {textContents.empName}
                        </label>
                      </Col>
                      <Col md={8}>
                        <label className="profileEmpSemicolon">:</label>
                        <label className="profileEmpLabel">
                          {profileData[0]?.name}
                        </label>
                      </Col>
                    </Row>
                  </Col>
                  <img src={HorizontalLine} width={40} />
                  <Col md={12}>
                    <Row>
                      <Col md={4}>
                        <label className="profileEmpLabel">
                          {textContents.role}
                        </label>
                      </Col>
                      <Col md={8}>
                        <label className="profileEmpSemicolon">:</label>
                        <label className="profileEmpLabel">
                          {profileData[0]?.RoleName
                            ? profileData[0]?.RoleName
                            : "-"}
                        </label>
                      </Col>
                    </Row>
                  </Col>
                  <img src={HorizontalLine} width={40} />
                  <Col md={12}>
                    <Row>
                      <Col md={4}>
                        <label className="profileEmpLabel">
                          {textContents.contactNo}
                        </label>
                      </Col>
                      <Col md={8}>
                        <label className="profileEmpSemicolon">:</label>
                        <label className="profileEmpLabel">
                          {profileData[0]?.Contact
                            ? profileData[0]?.Contact
                            : "-"}
                        </label>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col md={5} className="profileEmpDetailDiv">
                <Row>
                  <Col md={12}>
                    <Row>
                      <Col md={4}>
                        <label className="vistoraLabel">
                          {textContents.magneticCardID}
                        </label>
                      </Col>
                      <Col md={8}>
                        <label className="profileEmpSemicolon">:</label>
                        <label className="profileEmpLabel">
                          {profileData[0]?.MagneticId
                            ? profileData[0]?.MagneticId
                            : "-"}
                        </label>
                      </Col>
                    </Row>
                  </Col>
                  <img src={HorizontalLine} width={40} />
                  <Col md={12}>
                    <Row>
                      <Col md={4}>
                        <label className="profileEmpLabel">
                          {textContents.email}
                        </label>
                      </Col>
                      <Col md={8}>
                        <label className="profileEmpSemicolon">:</label>
                        <label className="profileEmpLabel">
                          {profileData[0]?.Email ? profileData[0]?.Email : "-"}
                        </label>
                      </Col>
                    </Row>
                  </Col>
                  <img src={HorizontalLine} width={40} />
                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
      <ModalChangePassword
        show={modalOpenStatus}
        setShow={setModalOpenStatus}
        password={oldPassword}
        passwordNew={newPassword}
        passwordConfirm={PasswordConfirm}
        setOldPassword={setOldPassword}
        setPasswordNew={setNewPassword}
        setPasswordConfirm={setPasswordConfirm}
        passwordType={passwordType}
        setPasswordType={setPasswordType}
        newPasswordType={newPasswordType}
        setNewPasswordType={setNewPasswordType}
        confirmPasswordType={confirmPasswordType}
        setConfirmPasswordType={setConfirmPasswordType}
        oldPasswordInavalid={oldPasswordInvalid}
        newpasswordInavalid={newPasswordInvalid}
        confirmPasswordInavalid={confirmPasswordInvalid}
        passWordMisMatch={passWordMisMatch}
        setPasswordMisMatch={setPasswordMisMatch}
        handleSubmit={() => {
          passwordChange(oldPassword, newPassword);

          // // setModalOpenStatus(false);
        }}
      />
      <AlertBox
        alertMessage={alertMessage}
        show={showAlert}
        setShow={setShowAlert}
        handleSubmit={
          statusCode == 401 ? () => logout() : () => handleAlertSubmit()
        }
      />
    </div>
  );
};
export default ProfileViewPage;
